import axios from '@/axios-api';
import { getQuery } from '@/helpers/utils';
import Pathes from '@/helpers/pathes';

export const reportingService = {
  status: () => axios.get(Pathes.Reporting.status),
  modes: () => axios.get(Pathes.Reporting.modes),
  pendingReports: () => axios.get(Pathes.Reporting.pendingReports),
  submittedReports: params => axios.get(Pathes.Reporting.submittedReports + getQuery(params)),
  applyMode: payload => axios.post(Pathes.Reporting.applyMode, payload),
  detail: id => axios.get(Pathes.Reporting.detail(id)),
  submitDocuments: (id, payload) => axios.post(Pathes.Reporting.detail(id), payload),
};
